var _path, _polygon, _path2, _polygon2, _path3, _path4, _path5, _rect, _path6, _rect2, _polygon3, _rect3, _polygon4, _rect4, _rect5, _rect6, _rect7, _rect8, _path7, _path8, _rect9, _path9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _circle, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _circle2, _polygon5, _circle3, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawBuyHouse560D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1137,
    height: 531.16816,
    viewBox: "0 0 1137 531.16816",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "buy_house") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.39819,712.97183l-1.95117-.43945c21.75586-96.751,76.43018-184.60938,153.95117-247.3916A444.114,444.114,0,0,1,1021.553,711.35172l-1.94922.44335C973.55005,509.58609,796.32935,368.3605,588.634,368.3605,383.6604,368.3605,202.29956,513.29019,157.39819,712.97183Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1051.5 482.5 1054.5 504.5 1033.5 506.5 1036.5 479.5 1051.5 482.5",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M984,364.91592s2,27,2,28-14,70-14,70-20,38,0,37,14-36,14-36l21-58-9-41Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#a0616a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "985.5 482.5 982.5 504.5 1003.5 506.5 1000.5 479.5 985.5 482.5",
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M994,460.91592l-5,7s-3,30,0,40,9,56,9,59,1,5,0,6-4,1-2,3,2,8,2,8v5l13,74s-8,9-2,9,28,0,27-10l-2-1s-3-66-2-69,0-9,0-9-2-3,0-4,2-9,2-9l9-61s8,41,13,45,4,14,4,14l4,88s-4,10,0,12,21,9,22-1,6-97,6-101-1-6,0-9-1-3,0-3-2-3-2-5v-49s1-10,2-12-1-4,0-7-2-13-2-13l-45-12Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1029,684.91592s5-5-2-5a32.54943,32.54943,0,0,0-13,3l-5,18s-20.5,16.5,2.5,14.5,19.5-.5,19.5-.5,7-2,8-4-2-31-2-31S1034,687.91592,1029,684.91592Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1072,684.91592s-5-5,2-5a32.54943,32.54943,0,0,1,13,3l5,18s20.5,16.5-2.5,14.5-22.5-.5-22.5-.5-7-2-8-4,5-31,5-31S1067,687.91592,1072,684.91592Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 286.14105,
    y: 177.4318,
    width: 8.90262,
    height: 351.65343,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M408.70474,406.6619c.56672,122.96444-85.94527,223.04766-85.94527,223.04766s-87.43083-99.28154-87.99756-222.246,85.94527-223.04766,85.94527-223.04766S408.138,283.69746,408.70474,406.6619Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#6c63ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 225.5,
    y: 383.5,
    width: 689,
    height: 146,
    fill: "#f2f2f2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "203.5 399.5 278.5 242.5 877.5 242.5 933.5 399.5 203.5 399.5",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 390.5,
    y: 252.5,
    width: 278,
    height: 92,
    fill: "#f2f2f2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.5 177.5 364.5 269.5 694.5 269.5 668.5 177.5 408.5 177.5",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 412.5,
    width: 219.5,
    height: 117,
    fill: "#ccc"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 416.5,
    width: 117,
    height: 113,
    fill: "#ccc"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 672.5,
    y: 423.5,
    width: 60.5,
    height: 106,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 529,
    width: 1137,
    height: 2,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 179.9049,
    y: 297.05883,
    width: 5.87477,
    height: 232.05349,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271.49715,511.0473c.374,81.14332-56.71464,147.18749-56.71464,147.18749s-57.695-65.51515-58.06894-146.65847,56.71464-147.1875,56.71464-147.1875S271.12317,429.904,271.49715,511.0473Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.49715,511.0473c.374,81.14332-56.71464,147.18749-56.71464,147.18749s-57.695-65.51515-58.06894-146.65847,56.71464-147.1875,56.71464-147.1875S271.12317,429.904,271.49715,511.0473Z",
    transform: "translate(-31.5 -184.41592)",
    opacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 103.53286,
    y: 297.05883,
    width: 5.87477,
    height: 232.05349,
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M195.12511,511.0473c.374,81.14332-56.71464,147.18749-56.71464,147.18749s-57.695-65.51515-58.06894-146.65847,56.71465-147.1875,56.71465-147.1875S194.75114,429.904,195.12511,511.0473Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#6c63ff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 798.5,
    y: 429.5,
    width: 29.5,
    height: 27.5,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 838,
    y: 429.5,
    width: 29.5,
    height: 27.5,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 798.5,
    y: 467,
    width: 29.5,
    height: 28.5,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 838,
    y: 467,
    width: 29.5,
    height: 28.5,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 277.67391,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 446.91304,
    y: 277.67391,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 307.02174,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 446.91304,
    y: 307.02174,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 277.67391,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 619.91304,
    y: 277.67391,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 307.02174,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 619.91304,
    y: 307.02174,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 503,
    y: 277.67391,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 533.91304,
    y: 277.67391,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 503,
    y: 307.02174,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 533.91304,
    y: 307.02174,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 686,
    y: 434.23913,
    width: 14.53623,
    height: 13.55072,
    fill: "#f2f2f2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 705.46377,
    y: 434.23913,
    width: 14.53623,
    height: 13.55072,
    fill: "#f2f2f2"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 686,
    y: 452.71739,
    width: 14.53623,
    height: 14.04348,
    fill: "#f2f2f2"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 705.46377,
    y: 452.71739,
    width: 14.53623,
    height: 14.04348,
    fill: "#f2f2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 725,
    cy: 484,
    r: 4,
    fill: "#f2f2f2"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 425,
    width: 220,
    height: 2,
    fill: "#f2f2f2"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 434,
    width: 220,
    height: 2,
    fill: "#f2f2f2"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 443,
    width: 220,
    height: 2,
    fill: "#f2f2f2"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 452,
    width: 220,
    height: 2,
    fill: "#f2f2f2"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 461,
    width: 220,
    height: 2,
    fill: "#f2f2f2"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 470,
    width: 220,
    height: 2,
    fill: "#f2f2f2"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 479,
    width: 220,
    height: 2,
    fill: "#f2f2f2"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 488,
    width: 220,
    height: 2,
    fill: "#f2f2f2"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 497,
    width: 220,
    height: 2,
    fill: "#f2f2f2"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 506,
    width: 220,
    height: 2,
    fill: "#f2f2f2"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 515,
    width: 220,
    height: 2,
    fill: "#f2f2f2"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 425,
    width: 117,
    height: 2,
    fill: "#f2f2f2"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 434,
    width: 117,
    height: 2,
    fill: "#f2f2f2"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 443,
    width: 117,
    height: 2,
    fill: "#f2f2f2"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 452,
    width: 117,
    height: 2,
    fill: "#f2f2f2"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 461,
    width: 117,
    height: 2,
    fill: "#f2f2f2"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 470,
    width: 117,
    height: 2,
    fill: "#f2f2f2"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 479,
    width: 117,
    height: 2,
    fill: "#f2f2f2"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 488,
    width: 117,
    height: 2,
    fill: "#f2f2f2"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 497,
    width: 117,
    height: 2,
    fill: "#f2f2f2"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 506,
    width: 117,
    height: 2,
    fill: "#f2f2f2"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 515,
    width: 117,
    height: 2,
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 877,
    cy: 242,
    r: 81,
    fill: "#6c63ff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "928 234 885 234 885 191 869 191 869 234 826 234 826 250 869 250 869 293 885 293 885 250 928 250 928 234",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 975.5,
    cy: 75.5,
    r: 26,
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M998,278.91592s4,20,4,23,17,12,17,12l19-24s-12-17-12-21Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1013,304.91592s-8.71576-2.31982-11.35788-6.15991c0,0-27.64212,27.15991-27.64212,32.15991l22,39s0,14,2,15,0,0,0,4-6,30-4,34,4,1,2,7-7,38-7,38,18-6,44,4,57-4,57-4-8-18-6-24-5-17-5-17l-5-92s7-41,2-43l-10-4L1033.976,283.98S1026,303.91592,1013,304.91592Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#d0cde1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M984,323.91592l-10,7s-5,15,0,22,7,17,7,17l20-2Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#d0cde1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1058,332.91592s-5.79086,14.89077-4.58123,29.62368A15.614,15.614,0,0,0,1056,369.91592h0L985.05556,403.597S953,406.91592,961,420.91592s37-7,37-7,76-11,82-22,10-57,10-57Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M987.14914,232.43838l-4.51-1.80556s9.43-10.38191,22.55014-9.4791l-3.69011-4.06253s9.02-3.61106,17.22007,5.868c4.31058,4.983,9.298,10.84016,12.40712,17.43823h4.82992l-2.01583,4.43863,7.05541,4.43863-7.24168-.7973a24.561,24.561,0,0,1-.685,11.49557l.19411,3.50829s-8.39412-12.98745-8.39412-14.793v4.51388s-4.51-4.06247-4.51-6.77078l-2.46,3.15972-1.23-4.96529-15.17,4.96529,2.46-4.06247-9.43,1.35416,3.69011-4.96529s-10.66,5.868-11.07009,10.83332-5.7399,11.28466-5.7399,11.28466l-2.46-4.51388S975.25913,239.20916,987.14914,232.43838Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1061,291.91592h15s11,2,14,22,6,25,3,25-39-1-39-2S1061,291.91592,1061,291.91592Z",
    transform: "translate(-31.5 -184.41592)",
    fill: "#d0cde1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawBuyHouse560D);
export default __webpack_public_path__ + "static/media/undraw_buy_house_-560-d.e8692e70c7001025679185dee8fc760c.svg";
export { ForwardRef as ReactComponent };